import Lookup from 'src/componentes/select2';

const TipoAcesso = ({ clearable = false, ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    clearable={clearable}
    url="/TipoAcessoLookup"
    {...rest}
  />
);

export default TipoAcesso;
